module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-md-70ac65c0c78e321c8cf0651faf0c01b9.png";